module.exports = __webpack_public_path__ + "static/seal-of-cookies-f2929cfb014dedbdea404bd9e724e0f6.png";